import { render, staticRenderFns } from "./legal-checkbox-agreement.vue?vue&type=template&id=2be8b92f&scoped=true&"
import script from "./legal-checkbox-agreement.vue?vue&type=script&lang=js&"
export * from "./legal-checkbox-agreement.vue?vue&type=script&lang=js&"
import style0 from "./legal-checkbox-agreement.vue?vue&type=style&index=0&id=2be8b92f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8b92f",
  null
  
)

export default component.exports